import React from "react";
import "./gallery-pane.css";
import { timestamp } from "rxjs";
//Components

class GalleryPane extends React.Component {
	constructor(props) {
		super(props);
		this.pane = React.createRef();
		this.video = React.createRef();
		this.playButton = React.createRef();
		this.videoNumberTime = React.createRef();
		this.fsButton = React.createRef();
		this.audioButton = React.createRef();
		this.durationProgress = React.createRef();
		this.thumbContainer = React.createRef();

		this.scrolling = null;
		this.thumbs = null;
		this.extension = null;
		this.exts = {
			'jpg': 'Image',
			'jpeg': 'Image',
			'png': 'Image',
			'mp4': 'Video',
			'webm': 'Video'
		}

		this.mediaControlVisibilityTimer;

		this.state = {
			thumbLeftReached: true,
			thumbRightReached: false
		};
	}

	componentDidMount() {
		this.props.mode == 'web' &&
		('click mousedown mouseup mousemove touchstart touchend touchmove').split(' ').forEach(eType => {
			this.pane.current.addEventListener(eType, evt => {
				evt.stopPropagation();
				if (evt.target.tagName == 'VIDEO') {
					if (/click|touchstart/.test(eType) && !this.pane.current.classList.contains('hide-controls') ) {
						this.vidPlayToggle(evt);
					}
				}

				this.resetMediaControlVisibility();
			});
		});
	}

	componentDidUpdate(prevProps) {
		if (prevProps.thumbnails?.length !== this.props.thumbnails?.length) {
			this.checkScrollEnded();
		}

		if (this.props.mode == 'web' && prevProps.media !== this.props.media) {
			this.resetMediaControlVisibility();
		}
	}

	resetMediaControlVisibility = () => {
		clearTimeout(this.mediaControlVisibilityTimer);
		this.pane.current.classList.remove('hide-controls');
		this.mediaControlVisibilityTimer = setTimeout(() => {
			this.pane.current.classList.add('hide-controls');
		}, 2500);
	}

	checkScrollEnded = () => {
		this.setState({
			thumbLeftReached: this.thumbContainer?.current?.scrollLeft <= 0,
			thumbRightReached: (this.thumbContainer?.current?.scrollLeft + this.thumbContainer?.current?.offsetWidth) >= (this.thumbContainer?.current?.scrollWidth - 5)
		});
	}

	scrollLeft = e => {
		this._scrollTo(1);
	}

	scrollRight = e => {
		this._scrollTo(-1);
	}

	_scrollTo = (dir = 1) => {
		this.scrollStop();
		let pixelSpeed = this.thumbContainer?.current ? this.thumbContainer.current.clientWidth * 20 / 687 : 20;
		pixelSpeed = pixelSpeed * dir;
		this.scrolling = setInterval(() => {
			this.thumbContainer.current.scrollLeft -= pixelSpeed;
			this.checkScrollEnded();
		}, 8);
	}

	scrollStop = e => {
		if (this.scrolling)
			clearInterval(this.scrolling);
	}

	videoControl = state => {
		let vid = this.video.current;
		switch (state) {
			case "play":
				if (vid && vid.paused) {
					vid.play();
				}
				this.playButton.current?.classList.remove("paused");
				break;
			case "pause":
				if (vid && !vid.paused) {
					vid.pause();
				}
				this.playButton.current?.classList.add("paused");
				break;
			case "enterFullscreen":
				this.fsButton.current?.classList.add("fullscreen");
				this.pane.current?.classList.add("fullscreen");
				break;
			case "exitFullscreen":
				this.fsButton.current?.classList.remove("fullscreen");
				this.pane.current?.classList.remove("fullscreen");
				break;
			case "open":
				this.playButton.current?.classList.remove("paused");
				this.pane.current?.classList.remove("fullscreen");
				this.fsButton.current?.classList.remove("fullscreen");
				break;
			case "muted":
				if (vid) {
					vid.muted = true;
				}
				this.audioButton.current?.classList.add("muted");
				break;
			case "unmuted":
			if (vid) {
				vid.muted = false;
			}
			this.audioButton.current?.classList.remove("muted");
			break;
			default:
				if (vid && state && !isNaN(state)) {
					vid.currentTime = parseFloat(state);
				}
				break;
		}
	}

	playVid = e => {
		this.props.updateVidState(this.props.videoState === "pause" ? "play" : "pause");
	}

	vidTimeUpdate = e => {
		if (!this.video.current || this.props.mode == 'wall') return;
		let vid = this.video.current;
		let dMinutes = Math.floor(vid.duration / 60);
		let dSeconds = Math.floor(vid.duration % 60);
		dSeconds = (dSeconds < 10 ? "0" : "") + dSeconds;
		let duration = dMinutes + ':' + dSeconds;

		let cMinutes = Math.floor(vid.currentTime / 60);
		let cSeconds = Math.floor(vid.currentTime % 60);
		cSeconds = (cSeconds < 10 ? "0" : "") + cSeconds;
		let current = cMinutes + ':' + cSeconds;

		this.videoNumberTime.current.innerHTML = current + " / " + duration;
		this.durationProgress.current.style.width = (vid.currentTime / vid.duration * 100) + '%';
	}

	goFullscreen = e => {
		if (this.props.mode == 'web') {
			this.pane.current?.classList.toggle('fullscreen');
			this.fsButton.current?.classList.toggle('fullscreen');
		} else if (this.props.mode == 'kiosk') {
			if (this.fsButton.current?.classList.contains("fullscreen")) {
				this.props.updateVidState("exitFullscreen");
			}
			else {
				this.props.updateVidState("enterFullscreen");
			}
			return;
		}

		if (!this.video.current) return;

		if (this.props.mode != 'web') {
			if (this.video.current.requestFullscreen) {
				this.video.current.requestFullscreen();
			} else if (this.video.current.mozRequestFullScreen) { /* Firefox */
				this.video.current.mozRequestFullScreen();
			} else if (this.video.current.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
				this.video.current.webkitRequestFullscreen();
			} else if (this.video.current.msRequestFullscreen) { /* IE/Edge */
				this.video.current.msRequestFullscreen();
			}
		}
	}

	exitFullscreen = e => {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.mozCancelFullScreen) { /* Firefox */
			document.mozCancelFullScreen();
		} else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) { /* IE/Edge */
			document.msExitFullscreen();
		}
	}

	vidScrub = e => {
		if (!this.video.current) return;

		let bar = e.target.id ? e.target : e.target.parentNode;
		let barBox = bar.getBoundingClientRect();

		let percent = (e.clientX - barBox.x) / barBox.width;
		this.props.updateVidState(percent * this.video.current.duration);
	}

	vidPlayToggle = e => {
		e.preventDefault();
		let vid = this.video.current;
		if (!vid) {
			return;
		}

		this.props.updateVidState(vid.paused ? 'play' : 'pause');
	}

	doAudio = e => {
		if (!this.video.current) {
			return;
		}
		this.props.updateVidState(this.video.current.muted ? 'unmuted' : 'muted');
	}

	render() {
		this.thumbs = this.props.thumbnails || [];
		let thumbLeftReached = this.state.thumbLeftReached;
		let thumbRightReached = this.state.thumbRightReached;

		this.extension = this.props.media?.split('.').pop().toLowerCase();
		this.videoControl(this.props.videoState);

		return (
			<>
        {/* {this.props.mode == 'web' && <div id="gallery-pane-shade" className={this.props.media ? '' : 'hide'}></div>} */}
				{this.props.mode != 'kiosk' && <div ref={this.pane} id="galleryPane" className={this.props.media ? '' : 'hide'}>
					{this.exts[this.extension] === 'Image' && <img src={this.props.media} />}
					{this.exts[this.extension] === 'Video' && <video ref={this.video} src={this.props.media} onTimeUpdate={this.vidTimeUpdate} playsInline autoPlay loop muted={this.props?.mode != 'web'} disablePictureInPicture></video>}
					{this.props.mode == 'web' &&
          <div className="galleryPaneCloseBtn" onClick={e => this.props.closeViewer()}></div>
          }
				</div>}
				{this.props.mode != 'wall' && 
				<div className="thumb-wrapper">
					<div
						id="prevArrow"
						className={"prevArrow" + (this.props.thumbnails?.length > 0 ? '' : ' hide') + (thumbLeftReached ? ' disabled' : '')}
						onMouseDown={this.scrollLeft}
						onTouchStart={this.scrollLeft}
						onMouseUp={this.scrollStop}
						onMouseOut={this.scrollStop}
						onTouchEnd={this.scrollStop}
						onTouchCancel={this.scrollStop}>
					</div>
					<div id="thumbnails" className={this.props.thumbnails?.length > 0 ? '' : 'hide'}>
						<div ref={this.thumbContainer} className="thumb-imgs-wrapper">
						{(this.thumbs || []).map((item, i) => {
							return <div
								key={"thumb_" + i}
								onClick={e => this.props.toggleMedia(item.path)}
								data-type={this.exts[item.path.split('.').pop().toLowerCase()]}
								className={this.props.media === item.path ? 'active' : ''}>
								<div className="mediaCloseButton" onClick={e => this.props.toggleMedia(null)}></div>
								<img src={item.thumb} />
							</div>
						})}
						</div>
					</div>
					<div
						id="nextArrow"
						className={"nextArrow" + (this.props.thumbnails?.length > 0 ? '' : ' hide') + (thumbRightReached ? ' disabled' : '')}
						onMouseDown={this.scrollRight}
						onTouchStart={this.scrollRight}
						onMouseUp={this.scrollStop}
						onMouseOut={this.scrollStop}
						onTouchEnd={this.scrollStop}
						onTouchCancel={this.scrollStop}>
					</div>
				</div>}
				{this.props.mode != 'wall' && this.props.media && <div id="videoControls">
					<div ref={this.playButton} id="playButton" className={this.exts[this.extension] === 'Video' ? '' : 'hide'} onClick={this.playVid}></div>
					{this.props.mode == 'web' && <div ref={this.videoNumberTime} id="videoTime" className={this.exts[this.extension] === 'Video' ? '' : 'hide'}>-:-- / -:--</div>}
					<div ref={this.audioButton} id="audioButton" className={this.exts[this.extension] === 'Video' ? '' : 'hide'} onClick={this.doAudio}></div>
					<div ref={this.fsButton} id="fsButton" onClick={this.goFullscreen}></div>
				</div>}
				{this.props.mode == 'web' && this.exts[this.extension] === 'Video' && <div id="durationBar" onClick={this.vidScrub}>
					<div className="barBG"></div>
					<div className="barProgress" ref={this.durationProgress}></div>
				</div>}	
			</>
		);
	}
}

export default GalleryPane;